import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
export default (function (context) {
  var files = require.context('./modules', false, /\.js$/);

  var modules = {};
  files.keys().forEach(function (key) {
    modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default(context);
  });
  return {
    namespaced: true,
    modules: modules
  };
});